// extracted by mini-css-extract-plugin
export default {"title":"index_title_CJNNB","cut":"index_cut_M0U-C","name":"index_name_tazlj"};